import { IVehicleInitialState } from "../../../types/master/vehicleInterface";
import { VehicleActionTypes, VehicleActions } from "../../actionTypes/master/vehicleActionTypes";

const initialState: IVehicleInitialState = {
  vehicleList: [],
  vehicleData: {
    id: 0,
    vehicle_number: "",
    engine_number: "",
    chassis_number: "",
    vehicle_code: "",
    vehicle_type_id: 0,
    puc_expiry_date: "",
    fitness_expiry_date: "",
    permit_expiry_date: "",
    insurance_expiry_date: "",
    color: "",
    manufacturing_date: "",
    purchase_date: "",
    created_by: 0,
    type: ""
  },
  vehicleListPageCount: 0,
};

export default function vehicleReducer(state = initialState, action: VehicleActionTypes): IVehicleInitialState {
  switch (action.type) {
    case VehicleActions.SET_VEHICLE_LIST:
      return {
        ...state,
        vehicleList: action.payload,
      };

    case VehicleActions.SET_VEHICLE_LIST_PAGE_COUNT:
      return {
        ...state,
        vehicleListPageCount: action.payload,
      };

    case VehicleActions.SET_VEHICLE_DATA_BY_ID:
      return {
        ...state,
        vehicleData: action.payload,
      };

    default:
      return state;
  }
}
